export const logColumns = [
  {
    label: "一级类型",
    value: "typeGroup",
    width: "100"
  },
  {
    label: "二级类型",
    value: "typeZh",
    width: "120"
  },
  {
    label: "操作详情",
    value: "extra"
  },
  {
    label: "操作人员",
    value: "user.name",
    width: "100"
  },
  { label: "操作时间", value: "createAt", width: "160" }
]

export const typeOptions = [
  {
    value: "企业管理",
    label: "企业管理",
    children: [
      {
        value: "COMPANY_TRANSFER",
        label: "移交企业"
      },
      {
        value: "COMPANY_DELETE",
        label: "解散企业"
      }
    ]
  },
  {
    value: "组织架构",
    label: "组织架构",
    children: [
      {
        value: "COMPANY_USER_ADD",
        label: "添加成员"
      },
      {
        value: "COMPANY_USER_UPDATE",
        label: "编辑成员"
      },
      {
        value: "COMPANY_USER_DISABLE",
        label: "停用成员"
      },
      {
        value: "COMPANY_USER_ENABLE",
        label: "激活成员"
      },
      {
        value: "COMPANY_USER_EXPORT",
        label: "导出成员列表"
      },
      {
        value: "COMPANY_USER_INVITE_SETTING",
        label: "成员邀请设置"
      }
    ]
  },
  {
    value: "数据安全",
    label: "数据安全",
    children: [
      {
        value: "COMPANY_LOG_EXPORT",
        label: "导出管理日志"
      }
    ]
  },
  {
    value: "应用管理",
    label: "应用管理",
    children: [
      {
        value: "COMPANY_APP_EXPORT",
        label: "导出应用"
      },
      {
        value: "COMPANY_APP_DELETE",
        label: "删除应用"
      },
      {
        value: "COMPANY_APP_BATCH_EXPORT",
        label: "批量导出应用"
      },
      {
        value: "COMPANY_APP_TEMPLATE_DELETE",
        label: "删除应用模版"
      }
    ]
  },
  {
    value: "项目管理",
    label: "项目管理",
    children: [
      {
        value: "COMPANY_PROJECT_DELETE",
        label: "解散项目"
      },
      {
        value: "COMPANY_PROJECT_TEMPLATE_DELETE",
        label: "删除项目模版"
      },
      {
        value: "COMPANY_TASK_TEMPLATE_DELETE",
        label: "删除任务模版"
      }
    ]
  },
  {
    value: "互联管理",
    label: "互联管理",
    children: [
      {
        value: "COMPANY_CONNECT_INVITE",
        label: "邀请互联"
      },
      {
        value: "COMPANY_CONNECT_AGREE",
        label: "确认互联"
      },
      {
        value: "COMPANY_CONNECT_DISABLE",
        label: "解除互联"
      },
      {
        value: "COMPANY_CONNECT_ENABLE",
        label: "恢复互联"
      }
    ]
  }
]

export const typeMap = {
  COMPANY_TRANSFER: "移交企业",
  COMPANY_DELETE: "解散企业",
  COMPANY_USER_ADD: "添加成员",
  COMPANY_USER_UPDATE: "编辑成员",
  COMPANY_USER_DISABLE: "停用成员",
  COMPANY_USER_ENABLE: "启用成员",
  COMPANY_USER_EXPORT: "导出成员列表",
  COMPANY_USER_INVITE_SETTING: "成员邀请设置",
  COMPANY_LOG_EXPORT: "导出管理日志",
  COMPANY_APP_EXPORT: "导出应用",
  COMPANY_APP_DELETE: "删除应用",
  COMPANY_APP_BATCH_EXPORT: "批量导出应用",
  COMPANY_APP_TEMPLATE_DELETE: "删除应用模版",
  COMPANY_PROJECT_DELETE: "解散项目",
  COMPANY_PROJECT_TEMPLATE_DELETE: "删除项目模版",
  COMPANY_TASK_TEMPLATE_DELETE: "删除任务模版",
  COMPANY_CONNECT_INVITE: "邀请互联",
  COMPANY_CONNECT_AGREE: "确认互联",
  COMPANY_CONNECT_DISABLE: "解除互联",
  COMPANY_CONNECT_ENABLE: "恢复互联"
}
